<template>
  <div class="driver">
    <h2 class="driver__title">{{ $t(`${namespace}.title`) }}</h2>
    <div class="driver__line">
      <div v-if="driver && driver.img" class="driver__line--left-col">
        <div class="driver__img">
          <img :src="driver.img" :alt="driver.fullName">
        </div>
      </div>

      <div class="driver__line--right-col">
        <div v-if="driver && driver.fullName" class="driver__item mb-2">
          <div class="driver__item__label">{{ $t(`${namespace}.name`) }}</div>
          <div class="driver__item__value text--ellipsis" :title="driver.fullName">
            {{ driver.fullName }}
          </div>
        </div>

        <div v-if="driver && driver.phoneNumber" class="driver__item mb-2">
          <div class="driver__item__label">{{ $t(`${namespace}.cellPhone`) }}</div>
          <div class="driver__item__value text--ellipsis">{{ driver.phoneNumber | phoneWithDDD }}</div>
        </div>
      </div>
    </div>

    <div class="driver__line">
      <v-layout>
        <v-flex v-if="driver && driver.carModel" xs6>
          <div class="driver__item">
            <div class="driver__item__label">{{ $t(`${namespace}.carModel`) }}</div>
            <div class="driver__item__value text--ellipsis">{{ driver.carModel }}</div>
          </div>
        </v-flex>

        <v-flex v-if="driver && driver.carPlate" xs6>
          <div class="driver__item">
            <div class="driver__item__label">{{ $t(`${namespace}.carPlate`) }}</div>
            <div class="driver__item__value text--bold text--ellipsis">{{ driver.carPlate }}</div>
          </div>
        </v-flex>

        <v-flex v-if="driver && driver.carColor" xs6>
          <div class="driver__item">
            <div class="driver__item__label">{{ $t(`${namespace}.carColor`) }}</div>
            <div class="driver__item__value text--ellipsis">{{ driver.carColor }}</div>
          </div>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DriverInfo',
  props: {
    driver: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      namespace: 'Views.NewWebCallPage.rideList.details.driver'
    }
  }
}
</script>

<style lang="scss" scoped>
.driver {
  padding: 24px 0;
}

.driver__title {
  color: $gray-7;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  line-height: normal;
  margin-bottom: 16px;
}

.driver__line {
  display: flex;
  flex-direction: row;
}

.driver__line--left-col {
  width: 75px;
}

.driver__line--right-col {
  padding-left: 16px;
  width: calc(100% - 75px);
}

.driver__img {
  background-color: #fff;
  border-radius: 50%;
  height: 75px;
  overflow: hidden;
  margin-top: 7px;
  width: 75px;

  img {
    width: 75px;
    height: 75px;
    object-fit: cover;
  }
}

.driver__item__label {
  color: $gray-6;
  font-size: 12px;
}
</style>
